import { allTrackers } from "app/services/track/track";

import createAfterTrialEntryModalTrackingService from "./factory";

const afterTrialEntryModalTrackingService = createAfterTrialEntryModalTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default afterTrialEntryModalTrackingService;
